var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDlIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
    fill: "#FDC6C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3281 12.2344H15.1875C15.2648 12.2344 15.3281 12.1711 15.3281 12.0938V12.2344H20.6719V12.0938C20.6719 12.1711 20.7352 12.2344 20.8125 12.2344H20.6719V13.5H21.9375V12.0938C21.9375 11.4732 21.433 10.9688 20.8125 10.9688H15.1875C14.567 10.9688 14.0625 11.4732 14.0625 12.0938V13.5H15.3281V12.2344ZM24.1875 13.5H11.8125C11.5014 13.5 11.25 13.7514 11.25 14.0625V14.625C11.25 14.7023 11.3133 14.7656 11.3906 14.7656H12.4523L12.8865 23.959C12.9146 24.5584 13.4104 25.0312 14.0098 25.0312H21.9902C22.5914 25.0312 23.0854 24.5602 23.1135 23.959L23.5477 14.7656H24.6094C24.6867 14.7656 24.75 14.7023 24.75 14.625V14.0625C24.75 13.7514 24.4986 13.5 24.1875 13.5ZM21.8549 23.7656H14.1451L13.7197 14.7656H22.2803L21.8549 23.7656Z",
    fill: "#EA5455"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlIcon);
export default __webpack_public_path__ + "static/media/dl-icon.d5c41ee620cc687e4708c7ac493df04a.svg";
export { ForwardRef as ReactComponent };